// project imports
import getColors from 'utils/getColors';

// ==============================|| OVERRIDES - CHIP (soft pills, Brevo-like) ||============================== //

function soft({ color, theme }) {
  const { lighter, main, dark } = getColors(theme, color);
  return {
    color: dark,
    backgroundColor: lighter,
    border: `1px solid ${theme.vars.palette.grey[200]}`,
    '& .MuiChip-deleteIcon': { color: main, '&:hover': { color: dark } }
  };
}

export default function Chip(theme) {
  const defaultLight = soft({ color: 'secondary', theme });
  return {
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 999, fontWeight: 500, fontSize: '0.75rem', height: 24, width: 'fit-content', maxWidth: '100%' },
        sizeSmall: { height: 22, fontSize: '0.6875rem' },
        label: { paddingLeft: 10, paddingRight: 10 },
        sizeLarge: { fontSize: '0.875rem', height: 34 },
        // keep the Mantis custom variants used across the app
        light: {
          ...defaultLight,
          '&.MuiChip-lightPrimary': soft({ color: 'primary', theme }),
          '&.MuiChip-lightSecondary': soft({ color: 'secondary', theme }),
          '&.MuiChip-lightError': soft({ color: 'error', theme }),
          '&.MuiChip-lightInfo': soft({ color: 'info', theme }),
          '&.MuiChip-lightSuccess': soft({ color: 'success', theme }),
          '&.MuiChip-lightWarning': soft({ color: 'warning', theme })
        },
        combined: {
          ...defaultLight,
          '&.MuiChip-combinedPrimary': soft({ color: 'primary', theme }),
          '&.MuiChip-combinedSecondary': soft({ color: 'secondary', theme }),
          '&.MuiChip-combinedError': soft({ color: 'error', theme }),
          '&.MuiChip-combinedInfo': soft({ color: 'info', theme }),
          '&.MuiChip-combinedSuccess': soft({ color: 'success', theme }),
          '&.MuiChip-combinedWarning': soft({ color: 'warning', theme })
        },
        // MUI "filled" status colours become soft pills (most pages use <Chip color="success" size="small" />)
        filledSuccess: soft({ color: 'success', theme }),
        filledError: soft({ color: 'error', theme }),
        filledWarning: soft({ color: 'warning', theme }),
        filledInfo: soft({ color: 'info', theme }),
        filledPrimary: soft({ color: 'primary', theme }),
        filledSecondary: soft({ color: 'secondary', theme }),
        outlined: { backgroundColor: 'transparent' }
      }
    }
  };
}
